import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { InternalLibImage } from "../../../model/image-internal.class";
import { Observable } from "rxjs";
import { ModalGalleryService } from "../../modal-gallery/modal-gallery.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-item-audio-modal-gallery",
  standalone: true,
  imports: [],
  templateUrl: "./item-audio-modal-gallery.component.html",
  styleUrl: "./item-audio-modal-gallery.component.scss",
})
export class ItemAudioModalGalleryComponent implements OnInit, AfterViewInit {
  @ViewChild("audioRef") audioRef: ElementRef<HTMLAudioElement>;
  @Input() currentImage: InternalLibImage;
  @Output() contentLoaded = new EventEmitter();

  protected speed$: Observable<number>;
  private readonly modalGalleryService = inject(ModalGalleryService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.speed$ = this.modalGalleryService.speedAudio$;
  }

  ngAfterViewInit() {
    this.contentLoaded.emit();
    this.speed$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (speed) => {
        const audio = this.audioRef?.nativeElement;
        if (audio) {
          audio.playbackRate = speed;
        }
      },
      () => {},
      () => {
        this.modalGalleryService.resetAudioSpeed();
      }
    );
  }
}
